import React, { useMemo } from 'react';
import { checkBit } from '../../Utils/Functions';
import { CIRCLE_DM, COLORS_CIRCLE } from '../../Utils/Constants/ConstCircleDm';

const CircleDm = ({
    islink,
    angleCurrent,
    param4,
    offsetNulN,
    flagBarrier,
    angleForward,
    angleRevers
      }) => {

    //данные по положениию
  const angle_Current=Number(angleCurrent) || 0;
  const forward=checkBit(param4, 6);
  const revers=checkBit(param4, 4);
  const nowater=checkBit(param4, 3);
  const offset_NulN=offsetNulN ?? 0;
  //данные по барьерам
  const flag_Barrier = flagBarrier ?? 0;
  const angle_Forward = angleForward ?? 65535;
  const angle_Revers = angleRevers ?? 65535;
    //цвета 
  const colors = useMemo(() => {
    const isOnline = islink === 'Online';
    return {
        circle: isOnline ? (nowater ? (COLORS_CIRCLE.ONLINE.NOWATER_FILL) : (COLORS_CIRCLE.ONLINE.WATER_FILL)) : COLORS_CIRCLE.OFFLINE.FILL,
        outline: isOnline ? (nowater ? COLORS_CIRCLE.ONLINE.NOWATER_OUTLINE : COLORS_CIRCLE.ONLINE.WATER_OUTLINE) : COLORS_CIRCLE.OFFLINE.OUTLINE,

    };
}, [islink, nowater]);

  //линии и треугольник
const geometry = useMemo(()=>{
  // Углы в радианах
  const angleRad = (angle_Current - 90 + offset_NulN) * Math.PI / 180;
  const angleZeroRad = (offset_NulN - 90) * Math.PI / 180;
  //Координаты конечных точек линий
  const endX = CIRCLE_DM.CENTER_X + CIRCLE_DM.RADIUS * Math.cos(angleRad);
  const endY = CIRCLE_DM.CENTER_Y + CIRCLE_DM.RADIUS * Math.sin(angleRad);
  const endXZero = CIRCLE_DM.CENTER_X + CIRCLE_DM.RADIUS * Math.cos(angleZeroRad);
  const endYZero = CIRCLE_DM.CENTER_Y + CIRCLE_DM.RADIUS * Math.sin(angleZeroRad);

  // Расчет треугольника
  let trianglePoints = null;

  if (forward || revers) {

  const x2 = CIRCLE_DM.CENTER_X + (CIRCLE_DM.RADIUS - CIRCLE_DM.TRIANGLE_BASE) * Math.cos(angleRad);
  const y2 = CIRCLE_DM.CENTER_Y + (CIRCLE_DM.RADIUS - CIRCLE_DM.TRIANGLE_BASE) * Math.sin(angleRad);
  
  let triangleAngle;
  if (revers) triangleAngle = Math.atan2(y2 - endY, x2 - endX);
  if (forward) triangleAngle = Math.atan2(endY - y2, endX - x2);
  
  const x3 = (endX + x2) / 2 + (CIRCLE_DM.TRIANGLE_BASE / 2) * Math.cos(triangleAngle + Math.PI / 2);
  const y3 = (endY + y2) / 2 + (CIRCLE_DM.TRIANGLE_BASE / 2) * Math.sin(triangleAngle + Math.PI / 2);
  trianglePoints = [endX, endY, x2, y2, x3, y3].join(',');
}
  
  return { endX, endY, endXZero, endYZero, trianglePoints };

}, [angle_Current, offset_NulN, forward, revers]);

const barrier = useMemo (()=>{
    // нет барьеров - на выход
      if (flag_Barrier !== 1) {
        return null;
    }
  //Углы в радианах
    const angleFRad = (angle_Forward - 90 + offset_NulN) * Math.PI / 180;
    const angleRRad = (angle_Revers - 90 + offset_NulN) * Math.PI / 180;
    //Координаты конечных точек барьеров     
        return {
            endXF: CIRCLE_DM.CENTER_X + CIRCLE_DM.LINE_LENGTH_BARRIER * Math.cos(angleFRad),
            endYF: CIRCLE_DM.CENTER_Y + CIRCLE_DM.LINE_LENGTH_BARRIER * Math.sin(angleFRad),
            endXR: CIRCLE_DM.CENTER_X + CIRCLE_DM.LINE_LENGTH_BARRIER * Math.cos(angleRRad),
            endYR: CIRCLE_DM.CENTER_Y + CIRCLE_DM.LINE_LENGTH_BARRIER * Math.sin(angleRRad)
        };

}, [flag_Barrier, angle_Forward, angle_Revers, offset_NulN]);

  // Функция для создания дуги с учетом направления
  const describeArc = useMemo(()=>(x, y, radius, startAngleDeg, endAngleDeg) => {
    // нет барьеров - на выход
        if (flag_Barrier !== 1) {
          return "";
      }
    // Конвертируем градусы в радианы и корректируем на offsetNulN
    const startAngle = Math.PI * (startAngleDeg - 90 + offset_NulN) / 180;
    const endAngle = Math.PI * (endAngleDeg - 90 + offset_NulN) / 180;
    
    // Определяем направление дуги (по часовой стрелке)
    const sweepFlag = 1;
    
    // Вычисляем разницу углов
    let angleDiff = endAngle - startAngle;
    if (angleDiff < 0) angleDiff += 2 * Math.PI;
    
    // Определяем, нужно ли рисовать большую дугу
    const largeArcFlag = angleDiff > Math.PI ? 1 : 0;

    const start = {
      x: x + radius * Math.cos(startAngle),
      y: y + radius * Math.sin(startAngle)
    };
    const end = {
      x: x + radius * Math.cos(endAngle),
      y: y + radius * Math.sin(endAngle)
    };

    return [
      "M", start.x, start.y,
      "A", radius, radius, 0, largeArcFlag, sweepFlag, end.x, end.y
    ].join(" ");
  },[flag_Barrier, offset_NulN]);

    //флаги для отображения
    const showArc = flag_Barrier === 1 && 
                    angle_Forward !== CIRCLE_DM.BARRIER_DISABLED && 
                    angle_Revers !== CIRCLE_DM.BARRIER_DISABLED;

    const showForwardBarrier = flag_Barrier === 1 && angle_Forward !== CIRCLE_DM.BARRIER_DISABLED;
    const showReverseBarrier = flag_Barrier === 1 && angle_Revers !== CIRCLE_DM.BARRIER_DISABLED;
    const showTriangle = islink === 'Online' && revers !== forward;

  return (
    <svg width={80} height={80}>
      {/* Окружность */}
      <circle
        cx={CIRCLE_DM.CENTER_X}
        cy={CIRCLE_DM.CENTER_Y}
        r={CIRCLE_DM.RADIUS}
        stroke={colors.outline}
        strokeWidth={2}
        fill={colors.circle}
      />

       {/* Дуга разрешенной зоны */}
       {showArc &&(
        <path
          d={describeArc(CIRCLE_DM.CENTER_X,
           CIRCLE_DM.CENTER_Y,
           CIRCLE_DM.RADIUS/2,
           angle_Revers,
           angle_Forward)}
          fill="none"
          stroke="gray"
          strokeWidth="2"
        />
      )}

      {/* Линия от центра до края окружности-нулевое положение*/}
      <line
        x1={CIRCLE_DM.CENTER_X}
        y1={CIRCLE_DM.CENTER_Y}
        x2={geometry.endXZero}
        y2={geometry.endYZero}
        stroke="yellow"
        strokeWidth={3}
      />

      {/* Линия от центра до края окружности основная линия - текущее положение*/}
      <line
        x1={CIRCLE_DM.CENTER_X}
        y1={CIRCLE_DM.CENTER_Y}
        x2={geometry.endX}
        y2={geometry.endY}
        stroke="black"
        strokeWidth={2}
      />

      {/* Линия от центра за край окружности - барьер при движении вперед*/}
      {showForwardBarrier && (
      <line
        x1={CIRCLE_DM.CENTER_X}
        y1={CIRCLE_DM.CENTER_Y}
        x2={barrier.endXF}
        y2={barrier.endYF}
        stroke="gray"
        strokeWidth={2}
      />
      )}

       {/* Линия от центра за край окружности - барьер при движении назад*/}
       {showReverseBarrier && (
       <line
        x1={CIRCLE_DM.CENTER_X}
        y1={CIRCLE_DM.CENTER_Y}
        x2={barrier.endXR}
        y2={barrier.endYR}
        stroke="gray"
        strokeWidth={2}
      />
      )}

      {/* Центр окружности - точка */}
      <circle
        cx={CIRCLE_DM.CENTER_X}
        cy={CIRCLE_DM.CENTER_Y}
        r={2}
        stroke={"#000000"}
        strokeWidth={1}
        fill={"#000000"}
      />

      {/* Треугольник на конце линии */}
      {showTriangle && geometry.trianglePoints && (<polygon
        points={geometry.trianglePoints}
        fill="green"
        stroke="black"
        strokeWidth={1}
      />)
      }     
    </svg>
  );
};

export default CircleDm;